/**
 * Created by mykurisu on 2017/8/8.
 */
import React from 'react'
import {connect} from 'react-redux'
import CurrencyItem from '../search/CurrencyItem'
import {WKCurrencyItem} from '../../components/wk'
import '../../styles/search/SearchPage.css'

class SearchLecture extends React.Component {

    render() {
        const {search} = this.props;
        return (
            <div className="search-page-lecture">
                {search.lecture_list.map((item) => <WKCurrencyItem content={item} key={item.id} type={"lecture"}/>)}
            </div>
        )
    }
}

export default connect(state => ({
    search: state.search
}))(SearchLecture)


// WEBPACK FOOTER //
// ./src/components/search/SearchLecture.js